import {SvgImageToggleButton} from "../../../../fundamentals/CCOSvgToggleButtonGroup";
import {PaymentMethod} from "../../types";

export interface PaymentMethodButton extends SvgImageToggleButton {
    value: PaymentMethod;
}

export const paymentMethodButtons:PaymentMethodButton[] = [
    {
        value: PaymentMethod.Paypal,
        direction: "column",
        src: "/paypal.svg",
        srcActive: "/paypalActive.svg",
        image: {
            alt: "PayPal",
            src: "/paypal.svg",
            srcActive: "/paypalActive.svg",
            loading: "eager"
        },
        portraitImage: {
            alt: "PayPal",
            src: "/paypal.svg",
            srcActive: "/paypalActive.svg",
            width: 48,
            loading: "eager"
        },
        dataCypress: "paypal"
    },
    {
        value: PaymentMethod.PaypalSubscription,
        direction: "column",
        src: "/paypal.svg",
        srcActive: "/paypalActive.svg",
        image: {
            alt: "PayPal",
            src: "/paypal.svg",
            srcActive: "/paypalActive.svg",
            loading: "eager"
        },
        portraitImage: {
            alt: "PayPal",
            src: "/paypal.svg",
            srcActive: "/paypalActive.svg",
            width: 48,
            loading: "eager"
        },
        dataCypress: "paypal"
    },
    {
        value: PaymentMethod.SEPA,
        direction: "column",
        src: "/sepa.svg",
        srcActive: "/sepaActive.svg",
        image: {
            alt: "Lastschrift",
            src: "/sepa.svg",
            srcActive: "/sepaActive.svg",
            width: 125,
            loading: "eager"

        },
        portraitImage: {
            alt: "Lastschrift",
            src: "/sepaPortrait.svg",
            srcActive: "/sepaPortraitActive.svg",
            width: 45,
            loading: "eager"
        },
        dataCypress: "sepa"
    },

    {
        value: PaymentMethod.Card,
        direction: "column",
        src: "/card.svg",
        srcActive: "/cardActive.svg",
        image: {
            alt: "Kreditkarte",
            src: "/card.svg",
            srcActive: "/cardActive.svg",
            loading: "eager"
        },
        portraitImage: {
            alt: "Kreditkarte",
            src: "/card.svg",
            srcActive: "/cardActive.svg",
            width: 64,
            loading: "eager"
        },
        dataCypress: "card"
    },
    {
        value: PaymentMethod.ApplePay,
        direction: "column",
        src: "/applepay.svg",
        srcActive: "/applepayActive.svg",
        image: {
            alt: "ApplePay",
            src: "/applepay.svg",
            srcActive: "/applepayActive.svg",
            loading: "eager"
        },
        portraitImage: {
            alt: "ApplePay",
            src: "/applepay.svg",
            srcActive: "/applepayActive.svg",
            width: 64,
            loading: "eager"
        },
        dataCypress: "applepay"
    },
    {
        value: PaymentMethod.GooglePay,
        direction: "column",
        src: "/googlepay.svg",
        srcActive: "/googlepayActive.svg",
        image: {
            alt: "GooglePay",
            src: "/googlepay.svg",
            srcActive: "/googlepayActive.svg",
            loading: "eager"
        },
        portraitImage: {
            alt: "GooglePay",
            src: "/googlepay.svg",
            srcActive: "/googlepayActive.svg",
            width: 70,
            loading: "eager"
        },
        dataCypress: "googlepay"
    },
];